'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _i18n = require('./../i18n/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Překladová komponenta
 */
var TranslateComponent = function (_React$Component) {
    (0, _inherits3.default)(TranslateComponent, _React$Component);

    function TranslateComponent() {
        (0, _classCallCheck3.default)(this, TranslateComponent);
        return (0, _possibleConstructorReturn3.default)(this, (TranslateComponent.__proto__ || (0, _getPrototypeOf2.default)(TranslateComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(TranslateComponent, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                component = _props.component,
                message = _props.message,
                otherProps = (0, _objectWithoutProperties3.default)(_props, ['component', 'message']);
            var _context = this.context,
                fieldLabelPrefix = _context.fieldLabelPrefix,
                formPath = _context.formPath;


            var text = void 0;
            if (!message) {
                throw new Error('Message for translate not specified!!');
            }
            if (fieldLabelPrefix) {
                if (Array.isArray(fieldLabelPrefix)) {
                    var keys = fieldLabelPrefix.map(function (key) {
                        return formPath ? key + message.substring(formPath.length) : key + message;
                    });
                    text = (0, _i18n2.default)(keys);
                } else {
                    if (formPath) {
                        text = (0, _i18n2.default)(fieldLabelPrefix + message.substring(formPath.length));
                    } else {
                        text = (0, _i18n2.default)(fieldLabelPrefix + message);
                    }
                }
            } else if (typeof message === "string") {
                text = (0, _i18n2.default)('^' + message);
                if (text === null) {
                    text = message;
                }
            }

            return _react2.default.createElement(component, otherProps, text);
        }
    }]);
    return TranslateComponent;
}(_react2.default.Component);

TranslateComponent.PropTypes = {
    message: _react2.default.PropTypes.string.isRequired
};
TranslateComponent.defaultProps = {
    component: _reactstrap.Label
};
TranslateComponent.contextTypes = {
    fieldLabelPrefix: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.array]),
    formPath: _react2.default.PropTypes.string
};
exports.default = TranslateComponent;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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